import React, {useState, useEffect} from 'react';
import root from 'window-or-global';
import TaxRecordDialog from './TaxRecordDialog';
import TaxRecordProfile from './TaxRecordProfile';
import taxActions from '../../../../actions/tax.actions';
import alertsAction from '../../../../actions/alerts.actions';
import taxAction from '../../../../actions/tax.actions';
import influencerActions from '../../../../actions/influencer.actions';
import TaxProfileInterviewInfo from './TaxProfileInterviewInfo';
import {resetQueryParams} from '../../../../utils/Utils';
import {UserActionEventType} from '../../../../utils/PayoutUtils';
import {getLocale} from 'epic-common/src/locale';
import {Icon, RedirectWithParams, selectMessages, svgs} from 'epic-diesel-common';
import {RootStateOrAny, useDispatch, useSelector} from 'react-redux';
import {PayoutState} from '../../../../reducers/payout';
import {selectPayout, selectTax} from '../../../../selectors';
import {hasRejectedNewTermsWithVBucks} from '../../../../utils/ValidationUtils';

//@ts-ignore
import styles from './TaxProfile.pcss';

const TaxProfile = () => {
    const dispatch = useDispatch();
    const messages = useSelector<RootStateOrAny, Record<string, string>>(selectMessages);
    const taxState = useSelector<RootStateOrAny, any>(selectTax);
    const payoutState = useSelector<RootStateOrAny, PayoutState>(selectPayout);

    const [open, setOpen] = useState(false);
    const [installing, setInstalling] = useState(true);

    const receiveMessage = event => {
        if (event.data && event.data === 'exitConfirmed') {
            dispatch(taxActions.resetInterview());
            dispatch(taxAction.resetLoading());
            setTimeout(() => {
                dispatch(taxAction.getAccountStatus());
                dispatch(taxAction.getTaxRecord());
                dispatch(influencerActions.getInfluencerProfile());
                dispatch(alertsAction.getAlerts());
            }, 5000);
        }
    };

    function onCreateTaxProfile() {
        setOpen(true);
    }

    function onConsent() {
        const locale = getLocale();
        dispatch(taxAction.consentForPayment({locale}));
    }

    function scrollToOfflinePaymentAccount() {
        const element = root.document.querySelector('#payout-section');
        if (element) {
            setTimeout(() => {
                root.scrollTo({
                    behavior: 'smooth',
                    top: element.offsetTop
                });
            }, 300);
        }
    }

    function onSetEventAction(event) {
        const {eventName} = event.detail || {};
        switch (eventName) {
            case UserActionEventType.CREATE_TAX_PROFILE:
                onCreateTaxProfile();
                break;
            case UserActionEventType.CONSENT:
                onConsent();
                break;
            case UserActionEventType.OFFLINE:
                scrollToOfflinePaymentAccount();
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        setInstalling(false);
        dispatch(taxActions.getOrganizations());

        if (root.location) {
            const searchParams = new URL(root.location.href).searchParams;
            const routerParam = [
                UserActionEventType.CREATE_TAX_PROFILE,
                UserActionEventType.OFFLINE,
                UserActionEventType.CONSENT
            ].find(param => searchParams.get(param));

            if (routerParam) {
                resetQueryParams(routerParam);
                switch (routerParam) {
                    case UserActionEventType.CREATE_TAX_PROFILE:
                        onCreateTaxProfile();
                        break;
                    case UserActionEventType.OFFLINE:
                        scrollToOfflinePaymentAccount();
                        break;
                    default:
                        break;
                }
            }
        }

        root.addEventListener('NEED_ACTIONS', onSetEventAction);
        root.addEventListener('message', receiveMessage, false);

        return () => {
            root.removeEventListener('NEED_ACTIONS', onSetEventAction);
        };
    }, []);

    useEffect(() => {
        if (root.location) {
            const url = new URL(root.location.href).searchParams.get('isConsent');
            if (url) {
                resetQueryParams('isConsent');
                onConsent();
            }
        }
    }, [taxState.isConsent]);

    useEffect(() => {
        if (taxState.record) {
            dispatch(taxActions.getConsent());
        }
    }, [taxState.record]);

    if (taxState.isOffline) {
        return <RedirectWithParams to="overview" />;
    }

    if (taxState.loadingRecord || installing) {
        return (
            <div className={styles.loader}>
                <Icon className={styles.icon} icon={svgs.LOADING} fontSize="large" />
            </div>
        );
    }

    return [
        (taxState.submitted && taxState.retakeAvailable) || taxState.validated ? (
            <TaxRecordProfile
                key="profile"
                messages={messages}
                taxRecord={taxState.record}
                validated={taxState.validated}
                retakeAvailable={taxState.retakeAvailable}
                onOpen={() => setOpen(true)}
                hasRejected={hasRejectedNewTermsWithVBucks(payoutState.closedAccount)}
                updateRecord={(payload?) => {
                    dispatch(taxActions.updateTaxRecord(payload));
                }}
            />
        ) : (
            <TaxProfileInterviewInfo key="interviewInfo" onClick={() => setOpen(true)} />
        ),
        open && <TaxRecordDialog key="dialog" open={open} onClose={() => setOpen(false)} />
    ];
};

export default TaxProfile;
